export const PageDataState = {
    Searchs: {
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา'
        },
        faculty_id: {
            type: 'select',
            id: 'faculty_id',
            label: 'คณะ',
            value: '',
            placeholder: 'คณะ'
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        faculty_id: {
            type: 'select',
            id: 'faculty_id',
            label: 'คณะ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        department_id: {
            type: 'select',
            id: 'department_id',
            label: 'สาขาวิชา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },   
        department_work_id: {
            type: 'select',
            id: 'department_work_id',
            label: 'สาขางาน',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },                           
    },
    InputGroup: {}
}